var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_1153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 5.81387C18 12.3779 9.65973 17.691 9.30455 17.9105C9.21094 17.9692 9.1063 18 9 18C8.8937 18 8.78906 17.9692 8.69545 17.9105C8.34027 17.691 0 12.3779 0 5.81387C0.00148881 4.27247 0.52687 2.7947 1.46088 1.70476C2.39489 0.614826 3.66125 0.00173735 4.98214 0C6.64152 0 8.09437 0.832696 9 2.24022C9.90563 0.832696 11.3585 0 13.0179 0C14.3387 0.00173735 15.6051 0.614826 16.5391 1.70476C17.4731 2.7947 17.9985 4.27247 18 5.81387Z",
    fill: "#FE6F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_1153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillHeart);
export default __webpack_public_path__ + "static/media/fill_heart.5df365a3634190f223c4548269b52e51.svg";
export { ForwardRef as ReactComponent };